{
  "common": {
    "on": "On",
    "off": "Off",
    "yes": "Yes",
    "no": "No",
    "cancel": "Cancel",
    "networkError": "Network error — check connection"
  },
  "platform": {
    "shopify": "Shopify",
    "etsy": "Etsy",
    "woocommerce": "WooCommerce",
    "tiktok": "TikTok",
    "amazon": "Amazon",
    "printway": "Printway",
    "manual": "Manual",
    "unknown": "Unknown"
  },
  "statusLabels": {
    "Active": "Active",
    "Inactive": "Inactive",
    "Frozen": "Frozen",
    "Disconnected": "Disconnected"
  },
  "syncHealthLabels": {
    "healthy": "Healthy",
    "warning": "Warning",
    "critical": "Critical",
    "unknown": "Unknown"
  },
  "syncJobStatusLabels": {
    "succeeded": "Succeeded",
    "failed": "Failed",
    "running": "Running",
    "queued": "Queued",
    "dlq": "DLQ"
  },
  "autoPush": {
    "immediate": "Immediate",
    "30m": "30 min",
    "1h": "1 hour",
    "4h": "4 hours",
    "manual": "Manual"
  },
  "list": {
    "title": "Stores",
    "subtitle": "Manage store connections, monitor Sync Health and handle the DLQ. A frozen store holds incoming orders and pauses sync until it is reactivated.",
    "openQueueMonitor": "Open Queue Monitor →",
    "openBullBoardTitle": "Open Bull Board",
    "empty": "No stores match the filters.",
    "tabsAria": "Stores filter tabs",
    "tabs": {
      "all": "All",
      "active": "Active",
      "inactive": "Inactive",
      "frozen": "Frozen",
      "disconnected": "Disconnected"
    },
    "columns": {
      "name": "Name",
      "platform": "Platform",
      "merchant": "Merchant",
      "status": "Status",
      "syncHealth": "Health",
      "lastSync": "Last Sync",
      "lastSyncStatus": "Sync Status",
      "syncErrors24h": "Errors 24h",
      "products": "Products",
      "orders": "Orders",
      "webhooks": "Webhooks",
      "autoTracking": "Auto Tracking",
      "autoPush": "Auto Push",
      "tokenExpiry": "Token Expiry",
      "created": "Created"
    },
    "filters": {
      "search": {
        "label": "Search",
        "placeholder": "Shop domain, merchant…"
      },
      "platform": {
        "label": "Platform"
      },
      "syncHealth": {
        "label": "Sync Health"
      }
    },
    "actions": {
      "openStoreAria": "Open store {{name}}",
      "openStoreTitle": "Open store detail"
    },
    "legend": {
      "title": "Row legend:",
      "aria": "Row color legend",
      "criticalHealth": "Critical health",
      "frozen": "Frozen",
      "disconnected": "Disconnected"
    }
  },
  "kpi": {
    "totalStores": {
      "label": "Total stores",
      "sub": "across all merchants"
    },
    "active": {
      "label": "Active",
      "sub": "connected & syncing"
    },
    "attention": {
      "label": "Needs attention",
      "sub": "frozen or disconnected"
    }
  },
  "detail": {
    "missingId": "Missing store id in URL.",
    "loading": "Loading store detail…",
    "back": "Back to Stores",
    "statusTitle": "Connection status (OAuth + freeze state)",
    "platformLabel": "Platform:",
    "merchantLabel": "Merchant:",
    "tabsAria": "Store detail tabs",
    "tabs": {
      "info": "Info",
      "config": "Sync Config",
      "orders": "Orders",
      "products": "Products",
      "history": "Sync History",
      "health": "Sync Health",
      "webhook": "Webhook"
    },
    "actions": {
      "forceSync": "Force sync",
      "unfreeze": "Unfreeze",
      "unfreezing": "Unfreezing…",
      "freeze": "Freeze",
      "disconnect": "Disconnect"
    },
    "info": {
      "storeInfoTitle": "Store Info",
      "name": "Name",
      "platform": "Platform",
      "shopDomain": "Shop domain",
      "platformStoreId": "Platform store ID",
      "status": "Status",
      "connectedAt": "Connected at",
      "frozenReason": "Frozen reason",
      "merchantInvoicesTitle": "Merchant + Invoices (08.2)",
      "merchant": "Merchant",
      "merchantId": "Merchant id",
      "tokenExpiry": "Token expiry",
      "invoiceCrossLink": "Invoice info cross-link to Phase 8.2 lands in ADMIN-22.",
      "adminActionsLogTitle": "Admin Actions Log",
      "adminActionsLogBody": "Disconnect / freeze / unfreeze / force-sync audit log lands via task-45 (impersonation BE writes the audit rows).",
      "lastErrorFromSync": "Last error from sync:"
    },
    "config": {
      "title": "Sync Config",
      "productSync": "Product sync",
      "orderSync": "Order sync",
      "mappingAi": "Mapping AI",
      "autoPushInventory": "Auto-push inventory",
      "autoPushOrderConfig": "Auto-push order config"
    },
    "history": {
      "dlqBanner_one": "Errors older than {{count}} day are automatically purged.",
      "dlqBanner_other": "Errors older than {{count}} days are automatically purged.",
      "empty": "No syncs yet.",
      "columns": {
        "queue": "Queue",
        "status": "Status",
        "started": "Started",
        "finished": "Finished",
        "error": "Error"
      }
    },
    "webhook": {
      "title": "Webhook Registration",
      "secretPresent": "Secret present",
      "endpointToken": "Endpoint token",
      "scopes": "Scopes",
      "revealSecret": "Reveal secret",
      "remaskingIn": "Re-masking in {{seconds}}s…",
      "revealPrompt": "Confirm your admin password to view the webhook secret. The secret will be re-masked after 30s.",
      "autoRemaskNote": "the secret is automatically re-masked after 30 seconds."
    },
    "toast": {
      "unfrozenTitle": "Store unfrozen",
      "unfrozenDesc": "Connection status restored to Active.",
      "unfreezeFailTitle": "Unfreeze failed",
      "frozenTitle": "Store frozen",
      "frozenDesc": "{{name}} is now Frozen.",
      "syncQueuedTitle": "Sync queued",
      "syncQueuedDesc": "Job {{jobId}} has been scheduled.",
      "disconnectedTitle": "Store disconnected",
      "disconnectedDesc": "{{name}} has been disconnected."
    }
  },
  "syncHealth": {
    "title": "Sync Health",
    "subtitle": "24h error rate, 7-day sparkline and the most recent error history.",
    "errorRate24h": "Error rate 24h:",
    "dlqBanner_one": "Errors older than {{count}} day are automatically purged (DLQ TTL retention owned by Phase 5).",
    "dlqBanner_other": "Errors older than {{count}} days are automatically purged (DLQ TTL retention owned by Phase 5).",
    "sparklineTitle": "Sparkline (7 days)",
    "sparklineAria": "7-day error rate sparkline",
    "webhookTitle": "Webhook delivery (24h)",
    "webhookAria": "Webhook delivery stats (last 24h)",
    "received": "Received:",
    "processed": "Processed:",
    "failed": "Failed:",
    "recentErrorsTitle": "Recent errors (10 rows)",
    "recentErrorsAria": "Last 10 sync errors",
    "noRecentErrors": "No recent errors.",
    "loading": "Loading sync health…",
    "columns": {
      "queue": "Queue",
      "status": "Status",
      "class": "Class",
      "started": "Started",
      "retry": "Retry",
      "error": "Error"
    }
  },
  "orders": {
    "title": "Orders from store",
    "showingLatest_one": "Showing the latest {{count}} order by created_at.",
    "showingLatest_other": "Showing the latest {{count}} orders by created_at.",
    "totalAvailable": "Total orders available:",
    "viewAll": "View all in Admin Orders →",
    "loading": "Loading orders…",
    "empty": "No orders from this store yet.",
    "columns": {
      "orderNumber": "Order #",
      "status": "Status",
      "payment": "Payment",
      "items": "Items",
      "total": "Total",
      "received": "Received"
    }
  },
  "products": {
    "title": "Products on store",
    "subtitle": "Printway products are bound to the store through SKU mapping. See details in the Mapping Center.",
    "openMapping": "Open Mapping Center →",
    "pendingTitle": "Pending mapping (open)",
    "pendingSubtitle": "Unknown SKUs from the store that are not yet mapped to the Printway catalog. Total:",
    "loading": "Loading mapping…",
    "empty": "No pending mappings — every SKU has been resolved.",
    "columns": {
      "externalSku": "External SKU",
      "title": "Title",
      "status": "Status",
      "created": "Created"
    },
    "notePrefix": "The \"Mapped SKUs\" (resolved) list has no dedicated endpoint yet — it will be added once the BE exposes",
    "noteSuffix": "(Phase 8.1 amendment pending)."
  },
  "modals": {
    "disconnect": {
      "title": "Disconnect store",
      "descPrefix": "Disconnect store",
      "descSuffix": ". The OAuth refresh token will be deleted; the merchant will have to reconnect from scratch. Webhooks will stop receiving new events. This is a destructive action.",
      "confirmTypePrefix": "Type",
      "confirmTypeSuffix": "to confirm",
      "noteLabel": "Note (optional)",
      "notePlaceholder": "Reason for disconnecting (audit log)",
      "submit": "Disconnect store",
      "submitting": "Disconnecting…"
    },
    "forceSync": {
      "title": "Force sync",
      "descWithName": "Force a re-sync of \"{{name}}\". The system will add a sync_job to the BullMQ queue and the Phase 5 worker will process it as soon as it is free.",
      "descNoName": "Force a re-sync. The system will add a sync_job to the BullMQ queue and the Phase 5 worker will process it as soon as it is free.",
      "queueLabel": "Queue type",
      "queues": {
        "polling": "Polling — refetch orders + products",
        "orderImport": "Order Import — re-pull recent orders",
        "productSync": "Product Sync — push catalog updates"
      },
      "submit": "Force sync",
      "submitting": "Scheduling…"
    },
    "freeze": {
      "title": "Freeze store",
      "descWithName": "Freeze store \"{{name}}\". Sync will stop and the next orders will be held. The merchant will be notified. You can unfreeze it later.",
      "descNoName": "Freeze store. Sync will stop and the next orders will be held. The merchant will be notified. You can unfreeze it later.",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "E.g. policy violation / suspected fraud / merchant requested a pause",
      "reasonCounter": "{{len}}/{{max}} characters — minimum {{min}}.",
      "noteLabel": "Note (optional)",
      "notePlaceholder": "Internal note — not shown to the merchant",
      "submit": "Freeze store",
      "submitting": "Freezing…"
    }
  }
}
